/**
 * Parse a date string for display.
 *
 * Date-only strings (YYYY-MM-DD) are treated as calendar dates in the
 * local timezone — avoids the well-known bug where new Date("2026-10-31")
 * creates UTC midnight and shifts backward in negative-UTC timezones.
 *
 * Full ISO datetime strings (contain "T") are parsed normally.
 */
export function parseCalendarDate(dateStr) {
  if (!dateStr) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(dateStr);
}
